import React from "react";

import { ReactComponent as Circle } from "../../assets/images/gauge-circle.svg";
import { ReactComponent as PointerIcon } from "../../assets/images/gauge-pointer.svg";

function Pointer({ degree = 0, radius }) {
  const rotationStyle = `translate(0, 0) rotate(${degree}deg)`;

  return (
    <div className="gauge-container__pointer">
      <div className="gauge-icon-container">
        <PointerIcon
          className="pointer-indicator"
          style={{
            transform: rotationStyle,
            width: radius * (3 / 4)
          }}
        />
        <Circle
          className="circle"
          style={{ width: radius * (1 / 8), height: radius * (1 / 8) }}
        />
      </div>
    </div>
  );
}

export default Pointer;
